import { defineStore } from "pinia";
import { ref } from "vue";
import { fetchMenuList, type MenuListItem } from "@/services/oaOffice/role";

export const useUserRoleStore = defineStore(
	"userRole",
	() => {
		const menuList = ref<MenuListItem[]>([]);
		const btnTags = ref<string[]>([]);

		const getAdminMenuList = async () => {
			const res = await fetchMenuList();

			menuList.value = res.data.menu_list;
			btnTags.value = res.data.btn_tags;
		};

		return {
			menuList,
			btnTags,
			getAdminMenuList,
		};
	},
	{
		// 开启数据持久化
		persist: [
			{
				storage: localStorage,
			},
		],
	}
);
